export function getHostUrl(): string | undefined {
  return window.location.href ?? undefined
}
